import { render, staticRenderFns } from "./evaluaciones_coordinadores.vue?vue&type=template&id=5f245100&scoped=true"
import script from "./evaluaciones_coordinadores.vue?vue&type=script&lang=js"
export * from "./evaluaciones_coordinadores.vue?vue&type=script&lang=js"
import style0 from "./evaluaciones_coordinadores.vue?vue&type=style&index=0&id=5f245100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f245100",
  null
  
)

export default component.exports